import { defineApiInterceptor } from '@kouzoh/merpay-api-client';
import { Env } from '~/constants/env';
import Logger from '~/utils/logger';

export const createE2EInterceptor = (env: string, headers: Record<string, string>) =>
  defineApiInterceptor({
    name: 'e2e',
    onInit({ options }) {
      if (!process.server) return;

      if (env !== Env.Production) {
        const serviceRouterHeaders: Record<string, string> = {};
        for (const key of Object.keys(headers)) {
          if (key.includes('service-router-')) {
            serviceRouterHeaders[key] = headers[key];
          }
        }
        options.headers = {
          ...options.headers,
          ...serviceRouterHeaders,
        };
      }
      Logger.debug(headers);
    },
  });
